// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kxKC","col":"styles_col__18K7m","actions":"styles_actions__2gPkC","conflict":"styles_conflict__Ij8Ew"};